import React from 'react'
import AuthContext  from './Context';
class SysForms extends React.PureComponent{
  constructor(props){
    super(props);
    this.state={
      load:0,
      code:""
    }
    this.right = this.right.bind(this);
    this.sign = this.sign.bind(this);
    this.aboutus = this.aboutus.bind(this);
    this.checkin = this.checkin.bind(this);
    this.chat = this.chat.bind(this);
    this.signinSms = this.signinSms.bind(this);
    this.signin = this.signin.bind(this);
    this.signup = this.signup.bind(this);
    this.unlockrequiredAlert = this.unlockrequiredAlert.bind(this);
    this.resetPassword = this.resetPassword.bind(this);
    this.resetPasswordByAdmin = this.resetPasswordByAdmin.bind(this);
    this.profile = this.profile.bind(this);
    this.chooseApp = this.chooseApp.bind(this);
    this.quickAdd = this.quickAdd.bind(this);
    this.quickEdit = this.quickEdit.bind(this);
    this.objectPicker = this.objectPicker.bind(this);
    this.locationPicker = this.locationPicker.bind(this);
    this.objectView = this.objectView.bind(this);
    this.makeCall = this.makeCall.bind(this);
  }
  async componentDidMount(){
  }
  async right(user_group_id,user_group_name){
    let self = this;
    await new Promise( (resolve)=>{
      (async ()=>{
        if(!self.refRightForm){
          const {default:RightForm} = await import("./RightForm")
          self.setState({
            RightForm:<RightForm ref={ref=>self.refRightForm=ref}/>,
            load:self.state.load+1
          },()=>{
            setTimeout(()=>{
              resolve()
            },10)
          })
        }else{
          resolve()
        }
      })();
    })
    this.refRightForm.showForm(user_group_id,user_group_name);
  }
  async sign(title,user,data,onSuccess){
    let self = this;
    await new Promise( (resolve)=>{
      (async ()=>{
        if(!self.refSignForm){
          const {default:SignForm} = await import("./SignForm")
          self.setState({
            SignForm:<SignForm forwardedRef={ref=>self.refSignForm=ref}/>,
            load:self.state.load+1
          },()=>{
            setTimeout(()=>{
              resolve()
            },10)
          })
        }else{
          resolve()
        }
      })();
    })
    this.refSignForm.showForm(title,user,data,onSuccess);
  }
  async aboutus(){
    let self = this;
    await new Promise((resolve)=>{
      (async ()=>{
        if(!self.refAboutUs){
          const {default:AboutUsForm} = await import("./AboutUs")
          self.setState({
            AboutUsForm:<AboutUsForm  forwardedRef={ref=>self.refAboutUs=ref}/>,
            load:self.state.load+1
          },()=>{
            setTimeout(()=>{
              resolve()
            },10)
          })
        }else{
          resolve()
        }
      })();
    })
    this.refAboutUs.showForm();
  }

  async quickReport(code,condition={},title="Báo cáo"){
    let self = this;
    await new Promise((resolve)=>{
      (async ()=>{
        if(!self.refReport){
          const {default:ReportDrilldown} = await import("../ReportDrilldown")
          self.setState({
            ReportDrilldown:<ReportDrilldown
              ref={ref=>this.refReport=ref}
              fullWidth={true}
              maxWidth={'lg'}
            />,
            load:self.state.load+1
          },()=>{
            setTimeout(()=>{
              resolve()
            },10)
          })
        }else{
          resolve()
        }
      })();
    })
    this.refReport.open("report",code.toLowerCase(),condition,title);
  }

  async checkin(data){
    let self = this;
    await new Promise((resolve)=>{
      (async ()=>{
        if(!self.refCheckin){
          const {default:CheckinForm} = await import("../CheckinForm")
          self.setState({
            CheckinForm:<CheckinForm  forwardedRef={ref=>self.refCheckin=ref}/>,
            load:self.state.load+1
          },()=>{
            setTimeout(()=>{
              resolve()
            },10)
          })
        }else{
          resolve()
        }
      })();
    })
    this.refCheckin.showForm(data);
  }

  async chat(group,options){
    let self = this;
    await new Promise((resolve)=>{
      (async ()=>{
        if(!self.refChat){
          const {default:ChatQuick} = await import("../ChatQuick")
          self.setState({
            ChatQuick:<ChatQuick  ref={ref=>self.refChat=ref} history={this.props.history} location={this.props.location}/>,
            load:self.state.load+1
          },()=>{
            setTimeout(()=>{
              resolve()
            },10)
          })
        }else{
          resolve()
        }
      })();
    })
    this.refChat.open(group,options);
  }
  async signinSms(onSuccess,onError,options={allow_cancel:true}){
    //show form signin
    let self= this
    await new Promise((resolve)=>{
      (async ()=>{
        if(!self.signinsmsRef){
          try{
            let {default:SigninSmsForm} = await import("./SmsVerifyForm");
            self.setState({
              SigninSmsForm:<SigninSmsForm ref={ref=>self.signinsmsRef = ref}/>,
              load:self.state.load+1
            },()=>{
              setTimeout(()=>{
                resolve()
              },10)
            })
          }catch(e){
            self.context.alert("Can't load verify form, error: " + e.message);
          }
          
        }else{
          resolve();
        }
      })();
    })
    this.signinsmsRef.showForm(onSuccess,onError,options);
  }
  async signin(onSuccess,onError,options={allow_cancel:true}){
    let self = this;
    //show form signin
    await new Promise((resolve)=>{
      (async ()=>{
        if(!self.signinRef){
          let {default:SigninForm} = await import("./SigninForm");
          self.setState({
            SigninForm:<SigninForm ref={ref=>self.signinRef = ref}/>,
            load:self.state.load+1
          },()=>{
            setTimeout(()=>{
              resolve()
            },10)
          })
        }else{
          resolve();
        }
      })();
    })
    this.signinRef.showForm(onSuccess,onError,options);
  }
  
  async signup(data,onSuccess,onCancel){
    let self = this;
    await new Promise( (resolve)=>{
        (async ()=>{
          if(!self.signupRef){
            const {default:SignupForm} = await import("./SignupForm")
            self.setState({
              SignupForm:<SignupForm  ref={ref=>self.signupRef = ref}/>,
              load:self.state.load+1
            },()=>{
              setTimeout(()=>{
                resolve()
              },10)
            })
          }else{
            resolve()
          }
        })();
      }
    )
    this.signupRef.showForm(data,onSuccess,onCancel);
  }
  async unlockrequiredAlert(callback){
    let self = this;
    //show form signin
    await new Promise((resolve)=>{
      (async ()=>{
        if(!self.UnlockRequiredForm){
          let {default:UnlockRequiredForm} = await import("./UnlockRequiredForm");
          self.setState({
            UnlockRequiredForm:<UnlockRequiredForm forwardedRef={ref=>self.unlockRequiredForm = ref}/>,
            load:self.state.load+1
          },()=>{
            setTimeout(()=>{
              resolve()
            },10)
          })
        }else{
          resolve();
        }
      })();
    })
    this.unlockRequiredForm.showForm(callback);
  }

  async resetPassword(onSuccess){
    let self = this;
    await new Promise( (resolve)=>{
      (async ()=>{
        if(!self.resetPasswordRef){
          const {default:ResetPasswordForm} = await import("./ResetPasswordForm")
          self.setState({
            ResetPasswordForm:<ResetPasswordForm  ref={ref=>self.resetPasswordRef = ref}/>,
            load:self.state.load+1
          },()=>{
            setTimeout(()=>{
              resolve()
            },10)
          })
        }else{
          resolve()
        }
      })();
    })
    this.resetPasswordRef.showForm(onSuccess);
  }
  async resetPasswordByAdmin(email,id_app,onSuccess){
    let self = this;
    await new Promise( (resolve)=>{
      (async ()=>{
        if(!self.resetPasswordByAdminRef){
          const {default:ResetPasswordByAdmin} = await import("./ResetPasswordByAdmin")
          self.setState({
            ResetPasswordByAdmin:<ResetPasswordByAdmin  forwardedRef={ref=>self.resetPasswordByAdminRef = ref}/>,
            load:self.state.load+1
          },()=>{
            setTimeout(()=>{
              resolve()
            },10)
          })
        }else{
          resolve()
        }
      })();
    })
    this.resetPasswordByAdminRef.showForm(email,id_app,onSuccess);
  }
  async profile(onSuccess,options={tab:0}){
    
    
    if(options.close) return this.profileForm.handleClose();
    let self = this;
    await new Promise( (resolve)=>{
      (async ()=>{
        if(!self.profileForm){
          const {default:ProfileForm} = await import("./ProfileForm")
          self.setState({
            ProfileForm:<ProfileForm  ref={ref=>self.profileForm = ref}/>,
            load:self.state.load+1
          },()=>{
            setTimeout(()=>{
              resolve()
            },10)
            
          })
        }else{
          resolve()
        }
      })();
    })
    this.profileForm.showForm(onSuccess,options);
  }
  /**
   * @param {Function} onSuccess (appInfo)
   * @param {Function} [onCancel] gọi khi người dùng ĐÓNG hộp thoại mà chưa chọn công ty.
   *        Thiếu tham số này (như bản cũ) thì bên gọi sẽ chờ mãi không có hồi đáp.
   */
  async chooseApp(userInfo,onSuccess,onCancel){
    let self = this;
    console.log("choose app...");
    await new Promise( (resolve)=>{
      (async ()=>{
        if(!self.appsFormRef){
          const {default:AppsForm} = await import("./AppsForm")
          self.setState({
            AppsForm:<AppsForm  forwardedRef={ref=>self.appsFormRef = ref}/>,
            load:self.state.load+1
          },()=>{
            setTimeout(()=>{
              resolve()
            },10)
          })
        }else{
          resolve()
        }
      })();
    })
    console.log("choose app...showform");
    this.appsFormRef.showForm(userInfo,onSuccess,onCancel);
  }
  async quickAdd(code,data,callback){
    let self = this;
    this.setState({
      code
    },async ()=>{
      await new Promise( (resolve)=>{
        (async ()=>{
          if(!self._inputBase){
            const {default:InputBase} = await import(
              /* webpackPrefetch: true */
              /* webpackChunkName: "InputBase" */
              "../InputBase"
            );
            self.setState({
              InputBase,
              load:self.state.load+1
            },()=>{
              setTimeout(()=>{
                resolve()
              },10)
            })
          }else{
            resolve()
          }
        })();
      })
      this._inputBase.quickAdd(data,callback)
    })
  }
 async quickEdit(code,data,callback){
  let self = this;
  console.log("[sysForm] quickEdit");
  self.setState({
      code:code
    },async ()=>{
      await new Promise( (resolve)=>{
        (async ()=>{
          if(!self._inputBase){
            const {default:InputBase} = await import("../InputBase")
            self.setState({
              InputBase,
              load:self.state.load+1
            },()=>{
              setTimeout(()=>{
                resolve()
              },10)
            })
          }else{
            resolve()
          }
        })();
      })
      self._inputBase.quickEdit(data,callback)
    })
  }

  async objectPicker(code,title,options={}){
    let self = this;
    await new Promise((resolve)=>{
      (async ()=>{
        if(!self._objectPicker){
          let {default:ObjectPicker} = await import("../ObjectPicker");
          self.setState({
            ObjectPicker:<ObjectPicker ref={ref=>self._objectPicker = ref} fullWidth={true} formSize="lg"/>,
            load:self.state.load+1
          },()=>{
            setTimeout(()=>{
              resolve()
            },10)
          })
        }else{
          resolve();
        }
      })();
    })
    this._objectPicker.open(code,title,options.callback,options.condition,options.onClose,options.defaultData,options.props);
  }

  async locationPicker(title,options={}){
    let self = this;
    await new Promise((resolve)=>{
      (async ()=>{
        if(!self._locationPicker){
          let {default:LocationPicker} = await import("../LocationPicker");
          self.setState({
            LocationPicker:<LocationPicker ref={ref=>self._locationPicker = ref} fullWidth={true} formSize="lg"/>,
            load:self.state.load+1
          },()=>{
            setTimeout(()=>{
              resolve()
            },10)
          })
        }else{
          resolve();
        }
      })();
    })
    this._locationPicker.open(title,options);
  }
  async objectView(code,_id,options={}){
    let self = this;
    await new Promise((resolve)=>{
      (async ()=>{
        if(!self._objectView){
          let {default:ObjectView} = await import("../ObjectView");
          self.setState({
            ObjectView:<ObjectView ref={ref=>self._objectView = ref} fullWidth={true} formSize="lg"/>,
            load:self.state.load+1
          },()=>{
            setTimeout(()=>{
              resolve()
            },10)
          })
        }else{
          resolve();
        }
      })();
    })
    this._objectView.open(code,_id,options);
  }

  async makeCall(phoneNumber){
    if (!phoneNumber) {
      return;
    }
    const link = document.createElement('a');
    link.href = `tel:${phoneNumber}`;
    try {
      link.click();
    } catch (error) {
      alert(`Không thể tự động gọi. Vui lòng gọi thủ công số: ${phoneNumber}`);
    }
  }
  render(){
    return (
      <>
        {this.state.UnlockRequiredForm}
        {this.state.SigninForm}
        {this.state.SigninSmsForm}
        {this.state.SignupForm}
        {this.state.ResetPasswordForm}
        {this.state.ResetPasswordByAdmin}
        {this.state.ProfileForm}
        {this.state.AboutUsForm}
        {this.state.RightForm}
        {this.state.AppsForm}
        {this.state.SignForm}
        {this.state.ChatQuick}
        {this.state.CheckinForm}
        {this.state.ObjectPicker}
        {this.state.LocationPicker}
        {this.state.ObjectView}
        {this.state.ReportDrilldown}
        {this.state.InputBase &&
          <this.state.InputBase ref={ref=>this._inputBase = ref} noRender={true} code={this.state.code} rowsPerPage ={1000000}/>
        }
        {this.state.ReportBase &&
          <this.state.ReportBase ref={ref=>this._reportBase = ref}/>
        }
      </>
    )
  }
}
SysForms.contextType = AuthContext;
export default SysForms;
